import { DocumentNode, gql } from '@apollo/client'

export const CREATE_EVENT_DAY: DocumentNode = gql`
    mutation createEventDay(
        $daycare_id: Int!
        $title: String!
        $date: Date!
        $start_hour: Time!
        $end_hour: Time!
        $message: String!
        $reservation: Boolean!
        $places: Int!
        $attendant: Int!
        $attendant_min: Boolean!
        $sections: [Int]!
        $parent_only: Boolean
        $release_date: Datetime
        $expiry_date: Datetime
    ) {
        createEventDay(
            daycare_id: $daycare_id
            title: $title
            date: $date
            start_hour: $start_hour
            end_hour: $end_hour
            message: $message
            reservation: $reservation
            places: $places
            attendant: $attendant
            attendant_min: $attendant_min
            sections: $sections
            parent_only: $parent_only
            release_date: $release_date
            expiry_date: $expiry_date
        )
    }
`

export const GET_EVENT_DAY: DocumentNode = gql`
    query getEventDay($daycare_id: Int!, $from: Date, $to: Date) {
        getEventDay(daycare_id: $daycare_id, from: $from, to: $to) {
            id
            daycareId
            date
            startHour
            endHour
            title
            message
            reservation
            places
            placesBooked
            attendant
            attendantBooked
            attendantMin
            sections
            childsMatching {
                childName
                childId
            }
            booked
            parentOnly
            releaseDate
            expiryDate
        }
    }
`

export const DELETE_EVENT_DAY: DocumentNode = gql`
    mutation deleteEventDay($daycare_id: Int!, $event_id: Int!) {
        deleteEventDay(daycare_id: $daycare_id, event_id: $event_id)
    }
`

export const UPDATE_EVENT_DAY: DocumentNode = gql`
    mutation updateEventDay(
        $daycare_id: Int!
        $eventDay_id: Int!
        $title: String!
        $date: Date!
        $start_hour: Time!
        $end_hour: Time!
        $message: String!
        $reservation: Boolean!
        $places: Int!
        $attendant: Int!
        $attendant_min: Boolean!
        $sections: [Int]!
        $parent_only: Boolean
        $release_date: Datetime
        $expiry_date: Datetime
    ) {
        updateEventDay(
            daycare_id: $daycare_id
            eventDay_id: $eventDay_id
            title: $title
            date: $date
            start_hour: $start_hour
            end_hour: $end_hour
            message: $message
            reservation: $reservation
            places: $places
            attendant: $attendant
            attendant_min: $attendant_min
            sections: $sections
            parent_only: $parent_only
            release_date: $release_date
            expiry_date: $expiry_date
        )
    }
`

export const CREATE_RESERVATION_EVENT: DocumentNode = gql`
    mutation createReservationEvent(
        $event_id: Int!
        $childs_id: [Int]!
        $adults: [AdultReservationInput]
        $daycare_id: Int!
        $parent_id: Int
        $comment: String
    ) {
        createReservationEvent(
            event_id: $event_id
            childs_id: $childs_id
            adults: $adults
            daycare_id: $daycare_id
            parent_id: $parent_id
            comment: $comment
        )
    }
`

export const UPDATE_RESERVATION_EVENT: DocumentNode = gql`
    mutation updateReservationEvent(
        $reservation_id: Int!
        $event_id: Int!
        $childs_id: [Int]!
        $adults: [AdultReservationInput]
        $daycare_id: Int!
        $comment: String
    ) {
        updateReservationEvent(
            reservation_id: $reservation_id
            event_id: $event_id
            childs_id: $childs_id
            adults: $adults
            daycare_id: $daycare_id
            comment: $comment
        )
    }
`

export const GET_RESERVATION_EVENT: DocumentNode = gql`
    query getReservationEvent($event_id: Int!) {
        getReservationEvent(event_id: $event_id) {
            id
            eventId
            parentId
            nameUser
            reservationChild {
                id
                eventId
                parentId
                childId
                childName
                reservationId
            }
            reservationParent {
                id
                eventId
                parentId
                name
                selfReservation
                reservationId
            }
            daycareComment
            parentComment
        }
    }
`

export const GET_ALL_RESERVATION_EVENT: DocumentNode = gql`
    query getAllReservationEvent($event_id: Int!, $daycare_id: Int!) {
        getAllReservationEvent(event_id: $event_id, daycare_id: $daycare_id) {
            id
            eventId
            parentId
            nameUser
            reservationChild {
                id
                eventId
                parentId
                childId
                childName
                reservationId
            }
            reservationParent {
                id
                eventId
                parentId
                name
                selfReservation
                reservationId
            }
            daycareComment
            parentComment
        }
    }
`

export const DELETE_RESERVATION_EVENT: DocumentNode = gql`
    mutation deleteReservationEvent($reservation_id: Int!, $daycare_id: Int!, $comment: String) {
        deleteReservationEvent(reservation_id: $reservation_id, daycare_id: $daycare_id, comment: $comment)
    }
`

export const DAYCARE_HAVE_PASSED_EVENT: DocumentNode = gql`
    query daycareHavePassedEvents($daycareId: Int!, $date: Date) {
        daycareHavePassedEvents(daycareId: $daycareId, date: $date)
    }
`

export const DUPLICATE_EVENT_DAY: DocumentNode = gql`
    mutation duplicateEventDay($daycareId: Int!, $eventId: Int!, $dateList: [Date]!) {
        duplicateEventDay(daycareId: $daycareId, eventId: $eventId, dateList: $dateList)
    }
`

export const DELETE_ONE_RESERVATION_EVENT: DocumentNode = gql`
    mutation deleteOneReservationEvent(
        $reservationId: Int!
        $eventId: Int!
        $daycareId: Int!
        $childId: Int
        $parentId: Int
        $reservationParentId: Int
        $reservationChildId: Int
        $comment: String
    ) {
        deleteOneReservationEvent(
            reservationId: $reservationId
            eventId: $eventId
            daycareId: $daycareId
            childId: $childId
            parentId: $parentId
            reservationParentId: $reservationParentId
            reservationChildId: $reservationChildId
            comment: $comment
        )
    }
`
